import { updateSettings } from "../../stores/settings";
import { setScenario, setPresetScenario, type Scenario } from "./scenario";
import { getFoojiDomain } from "../../constants/provider";

const dashboardOrigins = [
  `https://${import.meta.env.FOOJI_DASHBOARD_SUBDOMAIN as string}.${getFoojiDomain()}`,
  ...((import.meta.env.FOOJI_DASHBOARD_ORIGINS as string | undefined)?.split(",").filter(Boolean) || [])
];

export const IFrame = {
  isInIFrame: () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      console.log("Error checking if in iframe", e);
      return true;
    }
  }
};

export const EditorHandlers = {
  enterEditingMode: () => {
    console.info("Entering editing mode. Disabling interaction...");
    document.body.style.pointerEvents = "none";
  },
  updateMicrositeConfig: (micrositeConfig: Record<string, unknown>) => {
    console.info("Updating microsite config and reloading the current route...");
    updateSettings(micrositeConfig);
  }
};

type EditorMessageEventData = {
  event: string;
  micrositeConfig?: Record<string, unknown>;
  presets?: Array<Scenario | string>;
};

export const MessagingHandler = {
  sendReadyMessage: (origin: string) => {
    try {
      window.parent.postMessage({ event: "microsite-ready" }, origin);
    } catch (err) {
      console.error(err);
    }
  },
  handleReceivedMessage: (event: MessageEvent<EditorMessageEventData>) => {
    if (typeof event.data === "object") {
      if (event.data.event === "enter-editing-mode") {
        EditorHandlers.enterEditingMode();
      } else if (event.data.event === "set-scenario") {
        if (event.data.presets) {
          console.log("Setting preset scenarios", event.data.presets);
          event.data.presets.forEach((preset) => {
            if (typeof preset === "string") {
              setPresetScenario(preset);
            } else {
              setScenario(preset);
            }
          });
        } else {
          console.warn("No presets provided. Ignoring...");
        }
      } else if (event.data.event === "update-microsite-config" && event.data.micrositeConfig) {
        EditorHandlers.updateMicrositeConfig(event.data.micrositeConfig);
      } else {
        console.warn(`Unrecognized postMessage event '${event.data.event}'`);
      }
    } else {
      console.warn("Received message data is not an object", event.data);
    }
  }
};

export const EventHandler = {
  handleEvent: (event: MessageEvent<EditorMessageEventData>) => {
    dashboardOrigins.includes(event.origin)
      ? MessagingHandler.handleReceivedMessage(event)
      : console.warn(`Ignoring incoming message from origin: ${event.origin}`);
  }
};

export const setupEditorMode = () => {
  if (IFrame.isInIFrame()) {
    window.addEventListener("message", EventHandler.handleEvent);

    console.info(`Parent found. Dispatching microsite-ready event to: ${dashboardOrigins?.join(", ")}`);
    for (const origin of dashboardOrigins) {
      MessagingHandler.sendReadyMessage(origin);
    }
  }
};
